"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'activate.loading.title': 'Activating Your Account',
    'activate.loading.message': 'Please wait while we activate your account...',
};
